import { DetailsContext } from 'pages/Main/Orders'
import { useContext } from 'react'

export const withOpenOrderAction = (Component) => (props) => {
  const { openOrder } = useContext(DetailsContext)

  return <Component {...props} openOrder={openOrder} />
}
